// src/setupFetchShim.js
// Intercepts window.fetch to:
// 1) rewrite http://localhost:8000 → chosen backend base (e.g. https://localhost:8000 or proxy "")
// 2) add credentials: 'include'
// 3) add X-CSRFToken for non-GET/HEAD requests to our backend origin

import { API_BASE, getCsrfToken } from "./lib/api"; // from your Frontend API Helper

const OLD_BASE = "http://localhost:8000";
const isBackendUrl = (url) =>
  typeof url === "string"
    ? url.startsWith(OLD_BASE) || url.startsWith(API_BASE)
    : url instanceof URL &&
      (url.href.startsWith(OLD_BASE) || url.href.startsWith(API_BASE));

const rewrite = (url) => {
  if (typeof url === "string") {
    if (url.startsWith(OLD_BASE)) return API_BASE + url.slice(OLD_BASE.length);
    return url; // already relative or another domain
  }
  if (url instanceof URL) {
    if (url.href.startsWith(OLD_BASE)) {
      return new URL(API_BASE + url.href.slice(OLD_BASE.length));
    }
    return url;
  }
  return url;
};

const origFetch = window.fetch.bind(window);
window.fetch = async function patchedFetch(input, init = {}) {
  // Normalize to URL string (or Request) and init
  let url = typeof input === "string" ? input : input?.url || input;
  let opts = { ...init };

  // Rewrite base for old hardcoded calls
  const target = rewrite(url);

  // If it’s our backend, enforce credentials and CSRF header for unsafe methods
  const method = (opts.method || (typeof input !== "string" && input?.method) || "GET").toUpperCase();
  const unsafe = method !== "GET" && method !== "HEAD";

  if (isBackendUrl(target)) {
    // Always send cookies for session auth
    opts.credentials = opts.credentials || "include";

    if (unsafe) {
      // merge headers and add CSRF
      const headers = new Headers(opts.headers || (typeof input !== "string" && input?.headers) || {});
      if (!headers.has("X-CSRFToken")) {
        const csrf = getCsrfToken();
        if (csrf) headers.set("X-CSRFToken", csrf);
      }
      // ensure JSON content-type if body is a plain object (common case)
      if (!headers.has("Content-Type") && opts.body && typeof opts.body === "object" && !(opts.body instanceof FormData)) {
        headers.set("Content-Type", "application/json");
        opts.body = JSON.stringify(opts.body);
      }
      opts.headers = headers;
    }
  }

  // Rebuild Request if original was a Request object (for compatibility)
  const finalInput =
    typeof input === "string" ? target :
    input instanceof Request ? new Request(target, { ...opts, method, headers: opts.headers || input.headers }) :
    target;

  return origFetch(finalInput, opts);
};
